import type { PropsWithChildren } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchCzListSets } from '@/api/sap/cz-list-set'
import { queryKeys } from '@/query/queryKeys'
import { CzListSetsContext } from './CzListSetsContext'

export function CzListSetsProvider({ children }: Readonly<PropsWithChildren>) {
  const query = useQuery({
    queryKey: queryKeys.czListSets(),
    queryFn: () => fetchCzListSets(),
    staleTime: Number.POSITIVE_INFINITY,
  })

  const czListSetsByCustomZone = Object.fromEntries(
    (query.data ?? []).map(czListSet => [czListSet.customZone, czListSet]),
  )

  return (
    <CzListSetsContext
      value={{
        czListSetsByCustomZone,
        isLoading: query.isLoading,
        isError: query.isError,
      }}
    >
      {children}
    </CzListSetsContext>
  )
}
